module.exports = __webpack_public_path__ + "assets/img/platform-logos.3e0519ac.png";